<template>
<div class="transfers-detail" v-if="flag==index&&detailShow" :style="{height:transferDetail.entities&&transferDetail.entities.length?transferDetail.entities.length*25+detailHeight+'px':detailHeight+'px'}">
    <div class="transfers-detail-title">{{$t('language.popup.transferDetails')}}</div>
    <div class="detail-count" v-if="transferDetail.state2.status==1">
         <div class="transfer-line" >{{$t('language.common.countFiles')}}:({{transferDetail.state2.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{transferDetail.state2.totalBytes|formatByte}})</div>
    </div>
    <div class="detail-one">
        <div class="transfer-line"><span style="float:left;cursor:pointer;"  @click.stop="toSourceCatalog(transferDetail.state2)" >{{$t('language.common.from')}}:</span>
            <div  class="catelog-color catelog-style"  :title="transferDetail.state2.sourceNode|getBusinessTransferCatalog">
                <span  @click.stop="toSourceCatalog(transferDetail.state2)" style="cursor:pointer;"> {{transferDetail.state2.sourceNode|getBusinessTransferCatalog}} </span>
            </div>
        </div>
        <div class="transfer-line" ><span style="float:left;cursor:pointer;" @click.stop="toAimCatalog(item)">{{$t('language.common.to')}}:</span>
            <div class="catelog-color catelog-style" :title="transferDetail.state2.desNode|getBusinessTransferCatalog">
                <span @click.stop="toAimCatalog(item)" style="cursor:pointer;"> {{transferDetail.state2.desNode|getBusinessTransferCatalog}} </span>
            </div>
        </div>
    </div>
     <div >
    <transition name="coll">
         <div class="more-transfers">
         <businessTransferThreads :threadChange='threadChange' :detailShow='detailShow' :syncItem='item' :flag='flag' :index='index'></businessTransferThreads>
         </div>
    </transition>
     </div>
   
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import googleAnalyticsUtil from "../../../../js/workspace/google_analytics_util.js";
//任务详情
import businessTransferThreads from "@/components/common/tabs/tabs_task_list/tabs_businessTransfer_threads";
export default {
    props: ['flag', 'index', 'transferDetail', 'speed', 'detailShow', 'percent', 'transferDetailChange','item'],
    data: function () {
        return {
            itemDetail: this.transferDetail,
            detailHeight: 238,
            user:commonUtils.getUser(),
            collapseFlage:false,
            threadChange: false, //用于子组件渲染界面
        }
    },
    watch: {
        transferDetailChange(newValue, oldValue) {
            this.$forceUpdate();
        },
          '$store.state.transferDetailChange': function (newValue, oldValue) {
            this.$forceUpdate();
            this.$parent.$forceUpdate();
            this.$parent.showTaskStatus();
        }
    },
    created() {
        if (this.transferDetail) {
            this.itemDetail = this.transferDetail;
        }
    },
    components:{
        businessTransferThreads
    },
    mounted() {

    },
    methods: {
        toSourceCatalog(item) {
                let fromItem = {
                    driveId: item.sourceToken,
                    nodes: item.sourceNode,
                    driveType: item.sourceCloudType,
                    name: item.sourceFilename,
                    id: item.sourceId
                };
                this.$parent.toSourceCatalog(fromItem,'businessTransfer');
        },
        toAimCatalog(item) {
           let name;
    if(item.toItem){
     name=item.toItem.name;
     }else{
     name=item.toItem.nodes[0].fileName;
    }
   let toItem = {
     driveId: item.toItem.driveId,
     nodes: item.toItem.nodes,
     driveType: item.toItem.driveType,
     name: name,
     id: item.toItem.id
    };
    this.$parent.toAimCatalog(toItem,'businessTransfer');
        },
        switchToPay() {
            googleAnalyticsUtil.pay1(this,"threads");
            commonUtils.switchToPay();
        },
        // isVip() {
        //     let flag = commonUtils.isVip();
        //     let boxHeight = 390;
        //     if (flag) {
        //         boxHeight = 350;
        //     } else {
        //         boxHeight = 390;
        //     }
        //     if(this.transferDetail&&!this.transferDetail.entities){
        //          this.transferDetail.entities=[];
        //     }
        //     this.$parent.$refs.threadParents.style.height = (this.transferDetail.entities.length) * 25 + boxHeight + 'px';
        //     let dom = this.$parent.$refs.threadParents.parentElement;
        //     let pDom = this.$parent.$refs.threadParents.parentElement.parentElement;
        //     dom.style.height = (this.transferDetail.entities.length) * 25 + boxHeight + 'px';
        //     pDom.style.height = (this.transferDetail.entities.length) * 25 + boxHeight + 'px';
        //     return flag;
        // },
          getTitle(item){
           var title;
           title=commonUtils.getCatalog(item.fileNode);
           title = title +'\\'+item.filename;
           return title;
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 39) {
                return value.slice(0, 39) + '...';
            }
            return value;
        },
    }
}
</script>

<style scoped>
.transfers-detail {
    width: 100%;
    height: 100%;
    height: 248px;
    /*no*/
    font-size: 12px;
    /*no*/
    line-height: 20px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding: 10px 20px 16px 20px;
    /*no*/
}

.transfers-detail-title {
    font-size: 16px;
    /*no*/
    font-weight: bold;
    color: #000;

}

.detail-one {
    width: 100%;
    height: 35px;
    /*no*/
    margin: 10px 0px 16px 0px;
    /*no*/
}


.detail-two {
    width: 100%;
    height: 50px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.detail-three {
    width: 100%;
    height: 35px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.detail-four {
    width: 100%;
    height: 35px;
    /*no*/
}

.transfer-line {
    width: 100%;
}

.transfer-column-left {
    width: 38%;
    float: left;
    margin-right: 3%;

}

.transfering-file-line {
    height: 25px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.transfer-column-right {
    width: 56%;
    float: left;

}

.transfer-line-des {
    line-height: 40px;
    /*no*/
}

.catelog-style {
    max-width: 1000Px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_businessTransfer_detail.vue